
const acceptButton = document.getElementById('age-gate-acceptance');
const denyButton =document.getElementById("age-gate-deny");
const ageGate = document.getElementById('age-gate');
const checkButton = document.getElementById('age-remember');
const audioButton = document.getElementById('volume-control');
const videos = document.querySelectorAll('video[data-video]');

function isHidden(el) {
  var style = window.getComputedStyle(el);
  return (style.display === 'none')
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;SameSite=Strict";
  }
  
  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

function checkCookie() {
    let agecookie = getCookie("agecookie");
    if (agecookie == "agegateaccepted") {
        ageGate.style.display = 'none';
    }else{
        ageGate.style.display = 'block';
      }
  }

  function toggleMute(videos, button){
    videos.forEach(function(video){
      if(!isHidden(video)){
        if(!video.paused){
          video.muted = !video.muted;
         } else {
           video.play();
            video.muted = !video.muted;
         }
      }else{
        video.paused;
      }
    });

    if(button.classList.contains("off")){
      button.classList.replace("off","on");
    }else if(button.classList.contains("on")){
      button.classList.replace("on","off");
    }
}

if(typeof(acceptButton) != 'undefined' && acceptButton != null){
  acceptButton.onclick = () => {
      ageGate.style.display = 'none';
      videos.forEach(function(video){
        if(!isHidden(video)){
          video.load();
        }
      });
      if(checkButton.checked){
      setCookie("agecookie", "agegateaccepted", 30);
      }
  }
}

audioButton.onclick = () => {
    toggleMute(videos,audioButton);
}

if(typeof(ageGate) != 'undefined' && ageGate != null){
  window.onload = (event) => {
      checkCookie();
  }
}

